var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c(
      "div",
      { staticClass: "page-titles border-bottom" },
      [
        _c("h3", [
          _vm._v("Transcripts\n      "),
          _vm.transcripts
            ? _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(
                  _vm._s(
                    _vm.trans("general.total_result_found", {
                      count: _vm.transcripts.total,
                    })
                  )
                ),
              ])
            : _c("span", { staticClass: "card-subtitle" }, [
                _vm._v(_vm._s(_vm.trans("general.no_result_found"))),
              ]),
        ]),
        _vm._v(" "),
        _c("sort-by", {
          staticClass: "pull-right",
          attrs: {
            "order-by-options": _vm.orderByOptions,
            "sort-by": _vm.filterTranscriptForm.sort_by,
            order: _vm.filterTranscriptForm.order,
          },
          on: {
            updateSortBy: (value) => {
              _vm.filterTranscriptForm.sort_by = value
            },
            updateOrder: (value) => {
              _vm.filterTranscriptForm.order = value
            },
          },
        }),
        _vm._v(" "),
        !_vm.showFilterPanel
          ? _c(
              "button",
              {
                staticClass: "btn btn-info btn-sm pull-right m-r-10",
                on: {
                  click: function ($event) {
                    _vm.showFilterPanel = !_vm.showFilterPanel
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-filter" }),
                _vm._v("  "),
                _c("span", { staticClass: "d-none d-sm-inline" }, [
                  _vm._v(_vm._s(_vm.trans("general.filter"))),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-20",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.trans("general.filter"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(_vm._s(_vm.trans("transcript.title"))),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterTranscriptForm.title,
                                    expression: "filterTranscriptForm.title",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { id: "title", name: "title" },
                                domProps: {
                                  value: _vm.filterTranscriptForm.title,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterTranscriptForm,
                                      "title",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 col-sm-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v(
                                  _vm._s(_vm.trans("transcript.participants"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterTranscriptForm.speaker,
                                    expression: "filterTranscriptForm.speaker",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "participants",
                                  name: "participants",
                                },
                                domProps: {
                                  value: _vm.filterTranscriptForm.speaker,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.filterTranscriptForm,
                                      "speaker",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.showFilterPanel
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm pull-right",
                                on: {
                                  click: function ($event) {
                                    _vm.showFilterPanel = !_vm.showFilterPanel
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.trans("general.cancel")))]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.transcripts.total
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.hasPermission("list-user") && _vm.transcripts.total
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table table-hover" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("transcript.held_at")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.trans("transcript.title"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.trans("transcript.participants")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Limited Partner"),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("General Partner"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "table-option",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.trans("general.action"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.transcripts.data,
                                      function (transcript) {
                                        return _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "white-space": "nowrap",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("momentDateTime")(
                                                    transcript.held_at
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", {
                                            domProps: {
                                              textContent: _vm._s(
                                                transcript.title
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("td", {
                                            staticClass:
                                              "pta-transcript-participants",
                                            staticStyle: {
                                              "max-width": "500px",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                transcript.speakers
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          transcript.investor
                                            ? _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    transcript.investor.name
                                                  )
                                                ),
                                              ])
                                            : _c("td", [_vm._v("-")]),
                                          _vm._v(" "),
                                          transcript.user
                                            ? _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    transcript.user.profile
                                                      .company
                                                  )
                                                ),
                                              ])
                                            : _c("td", [_vm._v("-")]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "table-option" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "btn-group" },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName: "v-tooltip",
                                                          value: _vm.trans(
                                                            "transcript.view_meeting_minutes"
                                                          ),
                                                          expression:
                                                            "trans('transcript.view_meeting_minutes')",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "btn btn-info btn-sm",
                                                      attrs: {
                                                        to: `/account/transcripts/${transcript.id}/meeting-minutes`,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-screen-users",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "router-link",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName: "v-tooltip",
                                                          value: "Data",
                                                          expression: "'Data'",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "btn btn-info btn-sm",
                                                      attrs: {
                                                        to: `/account/transcripts/${transcript.id}`,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-scroll",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination-record", {
                          attrs: {
                            "page-length": _vm.filterTranscriptForm.page_length,
                            records: _vm.transcripts,
                          },
                          on: {
                            "update:pageLength": function ($event) {
                              return _vm.$set(
                                _vm.filterTranscriptForm,
                                "page_length",
                                $event
                              )
                            },
                            "update:page-length": function ($event) {
                              return _vm.$set(
                                _vm.filterTranscriptForm,
                                "page_length",
                                $event
                              )
                            },
                            updateRecords: _vm.getTranscripts,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-info btn-sm pull-right m-r-10",
        staticStyle: { "margin-top": "5px" },
        attrs: { href: "/account/transcripts/test" },
      },
      [
        _c("i", { staticClass: "fas fa-keyboard" }),
        _vm._v("  "),
        _c("span", { staticClass: "d-none d-sm-inline" }, [_vm._v("AI Test")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-info btn-sm pull-right m-r-10",
        staticStyle: { "margin-top": "5px" },
        attrs: { href: "/account/transcripts/bio-test" },
      },
      [
        _c("i", { staticClass: "fas fa-keyboard" }),
        _vm._v("  "),
        _c("span", { staticClass: "d-none d-sm-inline" }, [_vm._v("Bio Test")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }